import styled from "@emotion/styled";
import { type FunctionComponent } from "react";

import {
  checkIsDigitalArchiveLink,
  checkIsInternalScmpLink,
} from "scmp-app/components/schema-render/common/link/helpers";
import type { ContentSchemaRenderProps } from "scmp-app/components/schema-render/content";
import type { contentSchemaRenderContent$data } from "scmp-app/queries/__generated__/contentSchemaRenderContent.graphql";

import { Text } from "./styles";

export type Props = ContentSchemaRenderProps & {
  className?: string;
  href?: string;
  reference?: contentSchemaRenderContent$data;
};

const Component: FunctionComponent<Props> = ({
  children,
  className,
  href = "",
  parentSchemaNode,
  ...attribs
}) => {
  const isInternalScmpLink = checkIsInternalScmpLink(href);
  const isDigitalArchiveLink = checkIsDigitalArchiveLink({
    className,
    isInternalScmpLink,
    parentSchemaNode,
  });

  if (isDigitalArchiveLink) return null;

  return <Text {...attribs}>{children}</Text>;
};

Component.displayName = "Link";
export const Link = styled(Component)``;
